import * as qs from 'qs';
import { axios } from '~/libs/axios';
import { Page, PaginationOptions, TChat } from '~/types';

const getOne = async (ID: string): Promise<TChat> => {
  const { data: chat } = await axios.get<TChat>(`/chats/${ID}`);
  return chat;
};

const getAll = async (options?: PaginationOptions): Promise<Page<TChat>> => {
  const queryParams = qs.stringify({
    limit: options?.size || 50,
    offset: ((options?.page || 1) - 1) * (options?.size || 50),
  });
  const { data } = await axios.get<Page<TChat>>('/chats?' + queryParams);
  return data;
};

export type CreateParams = {
  title: string;
};

const create = async ({ title }: CreateParams): Promise<TChat> => {
  const { data: chat } = await axios.post<TChat>('/chats', { title });
  return chat;
};

const update = async (
  chatID: string,
  { title }: { title: string },
): Promise<TChat> => {
  const { data: chat } = await axios.put<TChat>(`/chats/${chatID}`, { title });
  return chat;
};

const remove = async (chatID: string): Promise<void> => {
  await axios.delete(`/chats/${chatID}`);
};

export const chatsAPI = {
  getOne,
  getAll,
  create,
  update,
  remove,
};
